module.exports = __webpack_public_path__ + "static/img/fiberLast-fiberglass-embedded01.da24bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/fiberlast/fiberLast-fiberglass-embedded01.jpg
// module id = 770
// module chunks = 0